
import temp_1 from '../../images/quest_imgs/temp_1.jpg';
import temp_2 from '../../images/quest_imgs/temp_2.jpg';
import temp_3 from '../../images/quest_imgs/temp_3.jpg';
import temp_4 from '../../images/quest_imgs/temp_4.jpg';
import temp_5 from '../../images/quest_imgs/temp_5.jpg';
import temp_6 from '../../images/quest_imgs/temp_6.jpg';
import temp_7 from '../../images/quest_imgs/temp_7.jpg';
import temp_8 from '../../images/quest_imgs/temp_8.jpg';
import temp_9 from '../../images/quest_imgs/temp_9.jpg';
import temp_10 from '../../images/quest_imgs/temp_10.jpg';
import temp_11 from '../../images/quest_imgs/temp_11.jpg';
import temp_12 from '../../images/quest_imgs/temp_12.jpg';
import temp_13 from '../../images/quest_imgs/temp_13.jpg';
import temp_14 from '../../images/quest_imgs/temp_14.jpg';
import temp_15 from '../../images/quest_imgs/temp_15.jpg';
import temp_16 from '../../images/quest_imgs/temp_16.jpg';
import temp_17 from '../../images/quest_imgs/temp_17.jpg';
import temp_18 from '../../images/quest_imgs/temp_18.jpg';
import temp_19 from '../../images/quest_imgs/temp_19.jpg';
import temp_20 from '../../images/quest_imgs/temp_20.jpg';
import temp_21 from '../../images/quest_imgs/temp_21.jpg';
import temp_22 from '../../images/quest_imgs/temp_22.jpg';
import temp_23 from '../../images/quest_imgs/temp_23.jpg';
import temp_24 from '../../images/quest_imgs/temp_24.jpg';
import temp_25 from '../../images/quest_imgs/temp_25.jpg';
import temp_26 from '../../images/quest_imgs/temp_26.jpg';
import temp_27 from '../../images/quest_imgs/temp_27.jpg';
import temp_28 from '../../images/quest_imgs/temp_28.jpg';
import temp_29 from '../../images/quest_imgs/temp_29.jpg';
import temp_30 from '../../images/quest_imgs/temp_30.jpg';
import temp_31 from '../../images/quest_imgs/temp_31.jpg';
import temp_32 from '../../images/quest_imgs/temp_32.jpg';
import temp_33 from '../../images/quest_imgs/temp_33.jpg';
import temp_34 from '../../images/quest_imgs/temp_34.jpg';
import temp_35 from '../../images/quest_imgs/temp_35.jpg';
import temp_36 from '../../images/quest_imgs/temp_36.jpg';
import temp_37 from '../../images/quest_imgs/temp_37.jpg';
import temp_38 from '../../images/quest_imgs/temp_38.jpg';
import temp_39 from '../../images/quest_imgs/temp_39.jpg';
import temp_40 from '../../images/quest_imgs/temp_40.jpg';
import temp_41 from '../../images/quest_imgs/temp_41.jpg';
import temp_42 from '../../images/quest_imgs/temp_42.jpg';
import temp_43 from '../../images/quest_imgs/temp_43.jpg';
import temp_44 from '../../images/quest_imgs/temp_44.jpg';
import temp_45 from '../../images/quest_imgs/temp_45.jpg';
import temp_46 from '../../images/quest_imgs/temp_46.jpg';
const Temp_imgs = [
    temp_1,
    temp_2,
    temp_3,
    temp_4,
    temp_5,
    temp_6,
    temp_7,
    temp_8,
    temp_9,
    temp_10,
    temp_11,
    temp_12,
    temp_13,
    temp_14,
    temp_15,
    temp_16,
    temp_17,
    temp_18,
    temp_19,
    temp_20,
    temp_21,
    temp_22,
    temp_23,
    temp_24,
    temp_25,
    temp_26,
    temp_27,
    temp_28,
    temp_29,
    temp_30,
    temp_31,
    temp_32,
    temp_33,
    temp_34,
    temp_35,
    temp_36,
    temp_37,
    temp_38,
    temp_39,
    temp_40,
    temp_41,
    temp_42,
    temp_43,
    temp_44,
    temp_45,
    temp_46
]
export default Temp_imgs;

